import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

export const EditSpaceLogo: LoadableType<{
	isSpaceSettingsScreen?: boolean;
	showSpaceNameField?: boolean;
	spaceKey?: string;
	isOpen?: boolean;
	onOpen?: () => void;
	onClose?: () => void;
	entryPoint?: 'sideNav' | 'spaceSettings' | 'smartSpaceOverview';
}> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-EditSpaceLogoEditSpaceLogo" */ './EditSpaceLogo/EditSpaceLogo.tsx'
			)
		).EditSpaceLogo,
});
